<template>
  <div>
    <div v-show="hasPermission(['IU EHS CATALOG VIEW'])">
      <div>
        <ehs-catalog-sidebar
          :categoriesOptions="categories"
          :typesOptions="types"
          :isSidebarActive="addNewDataSidebar"
          @closeSidebar="toggleDataSidebar"
          :data="sidebarData"
        />
      </div>
      <vs-row>
        <vs-col vs-lg="12">
          <vx-card :title="$t('ehs_catalog')">
            <template slot="actions">
              <vs-row>
                <div class="vx-colw-full px-1 mb-4 lg:w-1/2" v-if="allowEditing">
                <add-button @click="addNewData" :disabled="addNewDataSidebar" btnClass="w-full mt-1"/>
                </div>
                <div class="vx-col w-full px-1 mb-4" :class="[ allowEditing ? 'lg:w-1/2' : '']">
                  <vs-input
                    class="w-full mt-1"
                    icon="search"
                    :placeholder="$t('search')"
                    v-model="params.search"
                    @keypress.enter="search()"
                  />
                </div>
              </vs-row>
            </template>

            <vs-table
              stripe
              :data="catalogList"
              id="loading-catalog-list"
              class="vs-con-loading"
            >
              <template slot="thead">
                <th-sort :text="$t('agency')"         column="Category.Name" @sort="handleClickSort"/>
                <th-sort :text="$tc('type')|capitalize"           column="Types.name" @sort="handleClickSort"/>
                <th-sort :text="$t('activity_name')"  column="ehs_catalog.name" @sort="handleClickSort"/>
                <th-sort :text="$t('duration')"       width="10%" column="ehs_catalog.duration" @sort="handleClickSort"/>
                <th-sort :text="$t('regulation')"     column="ehs_catalog.regulation" @sort="handleClickSort"/>
                <th-sort :text="$t('frequency')"      column="ehs_catalog.frequency" @sort="handleClickSort"/>
                <vs-th class="qb-sticky">
                  <b>{{$t('actions')}}</b>
                </vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{data[indextr].agency}}</vs-td>
                  <vs-td class="text-left">{{data[indextr].type_name}}</vs-td>
                  <vs-td class="text-left">{{data[indextr].name}}</vs-td>
                  <vs-td>{{data[indextr].duration}}</vs-td>
                  <vs-td class="text-left">{{data[indextr].regulation}}</vs-td>
                  <vs-td class="text-left">{{data[indextr].frequency_name}}</vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <feather-icon
                      icon="EditIcon"
                      class="btn-icon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      @click.stop="editData(data[indextr])"
                      v-if="allowEditing"
                    />
                    <feather-icon
                      v-if="hasPermission(['IU EHS CATALOG DELETE'])"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="ml-2 btn-icon"
                      @click.stop="confirmDeleteRecord(data[indextr].id)"
                      @success="search()"
                    />
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td colspan="100%">
                    <div
                        v-if="data.length"
                        v-observe-visibility="infiniteHandler"
                      ></div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moduleCatalog from '@/store/catalog/moduleCatalog.js'
import EHSCatalogSidebar from './EHSCatalogSidebar.vue'
import general from '@/http/requests/general/index.js'
import AddButton from '@/views/components/buttons/AddButton.vue'
import ThSort from '@/views/components/ThSort.vue'
export default {
  components: {
    'ehs-catalog-sidebar': EHSCatalogSidebar,
    'v-select': vSelect,
     AddButton,
     ThSort
  },
  data() {
    return {
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      //select
      types: [],
      categories: [],
      lastPage:1,
      params: {
        page: 1,
        search: '',
        sortBy: ['ehs_catalog.created_at'],
        sort: ['desc']
      },
      allowEditing:false
    }
  },
  beforeMount() {
    this.$store.dispatch('clearGlobalEhsFilter')
    this.$store.dispatch('clearGlobalComplianceFilter')
  },
  mounted() {
    this.init()
    this.allowEditing = this.hasPermission(['IU EHS CATALOG EDIT'])
  },
  computed: {
    catalogList() {
      return this.$store.state.catalog.catalogList
    },
    allowed_to_see_module() {
      let allowed = localStorage.getItem('permissions').includes('IU EHS Module')
      return allowed
    }
  },
  created() {
    if (!moduleCatalog.isRegistered) {
      this.$store.registerModule('catalog', moduleCatalog)
      moduleCatalog.isRegistered = true
    }
  },
  methods: {
    init() {
      general.types()
        .then((res) => {
          this.types = res.data.types
        })
      general.categories()
        .then((res) => {
          this.categories = res.data.categories
        })
        this.search()
      //this.openLoading()
      //this.openLoadingSideBar()
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
      this.errors.clear()
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    confirmDeleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm_delete,
        text: this.$i18n.messages[this.$i18n.locale].delete_message_confirm,
        acceptText: this.$i18n.messages[this.$i18n.locale].delete,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deleteData,
        parameters: id
      })
    },
    deleteData(id) {
      this.$store.dispatch('catalog/deleteCatalog', id)
        .then(res => {
          this.$vs.notify({
            color: 'success',
            title: this.$i18n.messages[this.$i18n.locale].deleted,
            text: this.$i18n.messages[this.$i18n.locale].succesfull_delete,
          })
          this.$emit('success')
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: 'Item not found'
          })
        })
    },
    search() {
      this.topTableScroll()
      /* let orderSort=sort
      if (sortBy == this.params.sortBy) {
        if (this.params.sort[0] == 'ASC') {
          orderSort = 'DESC'
        }
      } */
      this.params.page = 1
      /* this.params.sortBy = [sortBy]
      this.params.sort = [orderSort] */
      //revisar despues
      this.getCatalogList()
        .then(res => { this.closeLoading() })
        .catch(err => { this.closeLoading() })
    },
    handleClickSort(e){
      this.params.sort=e.sort
      this.params.sortBy=e.sortBy
      this.search()
    },
    getCatalogList() {
      this.openLoading()
      return this.$store.dispatch('catalog/fetchCatalogList', this.params).then(res => {
        this.lastPage = res.data.last_page
      })
    },
    infiniteHandler(isVisible) {
      if (!isVisible) { return }
      if (this.params.page >= this.lastPage) { return }
      this.params.page++
      this.getCatalogList()
        .then(res => { this.closeLoading() })
        .catch(err => { this.closeLoading() })
    },
    openLoading() {
      this.$vs.loading({
        container: '#loading-catalog-list',
        scale: 0.6
      })
    },
    openLoadingSideBar() {
      this.$vs.loading({
        container: '#loading-add-ehs-sidebar',
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close('#loading-catalog-list > .con-vs-loading')
      //this.$vs.loading.close('#loading-add-ehs-sidebar > .con-vs-loading')
    },
    topTableScroll(){
      let elemento = document.getElementsByClassName('vs-con-tbody vs-table--tbody');
      elemento[0].scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    }
  }
}
</script>
<style>
.btn-icon {
  cursor: pointer;
}

.autocomplete-input {
  width: 100% !important;
  border-radius: 5px;
  border: solid 1px lightgray !important;
  height: 2.7rem;
  font-size: 1rem;
  padding: 5px;
}

.autocomplete-result-list {
  background-color: #fff;
  border: solid 1px lightgray;
  line-height: 2rem;
  cursor: pointer;
  max-height: 10rem;
  overflow: auto;
}

.autocomplete-result-list li {
  padding: 0px 10px;
}

.autocomplete-result-list li:hover {
  background-color: #7167e8;
  background-size: cover;
  color: #ffffff;
  box-sizing: padding-box;
}

.vx-card__title h4 {
  margin-bottom: 2vh;
}
</style>